<template>
    <div>
        <ContentHeader :disabled="false" :title="lang('singleLeftMenuText3_3',language)" :tip_text_arr="headerTipArr"/>
        <Card>
            <Spin fix v-if="mbListLoading"></Spin>
            <p slot="title" :style="{textAlign:'left',fontSize:'18px',fontWeight:'bold'}">
                {{lang('singleMbPrimaryTitle',language)}}
            </p>
            <Row>
                <Col span="6" :style="{borderRight: '1px solid #E8E9F2'}">
                    <p :style="{color: '#4F6B87'}">{{lang('singleMbTipTitle1',language)}}</p>
                    <p :style="{fontFamily:'ArialMT',color: '#595959',fontSize:'36px'}">
                        {{totalBottles.total}}
                        <span :style="{fontSize:'18px'}">{{lang('singleMbText9',language)}}</span>
                    </p>
                </Col>
                <Col span="6" :style="{borderRight: '1px solid #E8E9F2'}">
                    <p :style="{color: '#4F6B87'}">{{lang('singleMbTipTitle2',language)}}</p>
                    <p :style="{fontFamily:'ArialMT',color: '#595959',fontSize:'36px'}">
                        {{totalBottleAccessedTimes.total}}
                        <span :style="{fontSize:'18px'}">{{lang('singleMbText5',language)}}</span>
                    </p>
                </Col>
                <Col span="6" :style="{borderRight: '1px solid #E8E9F2'}">
                    <p :style="{color: '#4F6B87'}">{{lang('singleMbTipTitle3',language)}}</p>
                    <p :style="{fontFamily:'ArialMT',color: '#595959',fontSize:'36px'}"  v-if="JSON.stringify(classifyingRatio) !== '{}'">
                        {{totalUserAccessBottles.total}}
                        <span :style="{fontSize:'18px'}">{{lang('singleMbText5',language)}}</span>
                    </p>
                </Col>
                <Col span="6" :style="{borderRight: '1px solid #E8E9F2'}">
                    <p :style="{color: '#4F6B87'}">{{lang('singleMbTipTitle4',language)}}</p>
                    <div v-for="(item,index) in hotBook">
                        <p :style="{fontSize: '18px',marginTop:'10px',fontWeight:'bold'}">
                            {{item.bookName}}
                        </p>
                    </div>
                </Col>
            </Row>
        </Card>
        <br>
        <SelectDate @increase="getDateRange"/>
        <Card>
            <Spin fix v-if="mbListLoading"></Spin>
            <p slot="title" :style="{textAlign:'left',fontSize:'18px',fontWeight:'bold'}">
                {{lang('singleMbText1',language)}}
            </p>
            <Row>
                <Col span="24" v-if="mbListArr.length>0">
                    <div class="mbWrapper" v-for="item in mbListArr" :key="item">
                        <div class="mbImgWrapper">
                            <img :src="item.bottleIcon" class="bottle"/>
                            <img :src="item.bookCoverUrl" class="bookCover"/>
                            <p>{{formatDate(item.sharedTime)}}</p>
                            <p>
                                {{lang('groupStatMbAccessTimesText',language)}}：
                                {{item.accessTimes === null || item.accessTimes === ''?0:item.accessTimes}}
                                {{lang('groupStatMbUnitText3',language)}}
                            </p>
                        </div>
                    </div>
                </Col>
                <Col span="24" v-else>
                    <p :style="{fontSize:'16px',fontWeight:'bold'}">{{lang('singleMbText7',language)}}</p>
                </Col>
            </Row>
            <br>
            <Page :total="total" show-sizer show-total show-elevator @on-change="changePage"
                  :page-size-opts="[10, 20, 30, 40, 50]" :page-size="pageSize"
                  @on-page-size-change="changePageSize" placement="top" width="" v-if="mbListArr.length>0"/>
        </Card>
    </div>
</template>

<script>
    var _hmt = _hmt || [];
    (function() {
        var hm = document.createElement("script");
        hm.src = "https://hm.baidu.com/hm.js?4537bce4a2128c98b476fa3bc3b18f86";
        var s = document.getElementsByTagName("script")[0];
        s.parentNode.insertBefore(hm, s);
    })();

    import {lang} from "@/utils/language.js";
    import store from '@/store/index.js';
    import config from '@/utils/config.js';
    import {formatDate} from "@/utils/common.js";
    import ContentHeader from '@/components/ContentHeader.vue';
    import {getSingleData} from '@/utils/net.js';
    import SelectDate from '@/components/SelectDate.vue';

    export default {
        name: "Mb",
        store,
        components: {
            ContentHeader,
            SelectDate
        },
        data() {
            return {
                lang: lang,
                formatDate: formatDate,
                stateLang: '',
                headerTipArr: [],
                mbListLoading:false,
                totalBottles: {},
                totalBottleAccessedTimes: {},
                totalUserAccessBottles: {},
                hotBook:[],
                userId: '',
                start: '',
                end: '',
                total: 0,
                page: 1,
                pageSize: 10,
                mbListArr:[],
            }
        },
        mounted() {
            this.loadHeaderTipArr();
        },
        methods:{
            loadHeaderTipArr() {
                this.headerTipArr.splice(0);
                for (var i = 1; i <= 4; i++) {
                    var item = {};
                    item.title = this.lang('singleMbTipTitle' + i, this.language);
                    item.content = this.lang('singleMbTipContent' + i, this.language);
                    if (JSON.stringify(item) !== '') {
                        this.headerTipArr.push(item);
                    }
                }
            },

            getMbList(){
                let that = this;
                that.mbListLoading = true;
                getSingleData({
                    context: that,
                    url: '/open/rfunc/mb/list/person',
                    params: {
                        start: that.start,
                        end: that.end,
                        page: that.page,
                        pageSize: that.pageSize,
                        de: config.de
                    },
                    onCallBack: function (retMap) {
                        that.totalBottles = retMap.primary.totalBottles;
                        that.totalBottleAccessedTimes = retMap.primary.totalBottleAccessedTimes;
                        that.totalUserAccessBottles = retMap.primary.totalUserAccessBottles;
                        that.hotBook = retMap.primary.hotBook;
                        that.total = retMap.total;
                        that.mbListArr = retMap.list;
                        that.mbListLoading = false;
                    },
                    onErr(res) {
                        that.$Message.error(this.lang('systemError', that.language));
                        that.mbListLoading = false;
                    }
                })
            },

            getDateRange(data) {
                this.start = data.t2;
                this.end = data.t1;
                this.getMbList();
            },
            changePage(page) {
                this.page = page;
                this.getMbList();
            },
            changePageSize(pageSize) {
                this.pageSize = pageSize;
                this.getMbList();
            },
        },
        computed: {
            language: function () {
                this.stateLang = store.state.lang;
                return store.state.lang;
            }
        },
        watch: {
            stateLang: function () {

            }
        },
        filters: {
            numFilter(value) {
                // 截取当前数据到小数点后两位
                let realVal = parseFloat(value).toFixed(2);
                // num.toFixed(2)获取的是字符串
                return parseFloat(realVal);
            }
        }
    }
</script>

<style scoped>
    .mbWrapper {
        width: 160px;
        height: 200px;
        float: left;
    }

    .mbImgWrapper {
        border: solid dodgerblue 2px;
        width: 150px;
        height: 150px;
        border-radius: 20px;
    }

    .bottle {
        position: relative;
        top: 5px;
        left: 18px;
        width: 90px;
    }

    .bookCover {
        position: relative;
        left: -45px;
        top: -15px;
        width: 38px;
    }
</style>